var NamecardModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default NamecardModal = Vue.extend({
  components: {
    modal: Modal
  },
  props: {
    namecard: {
      type: Object
    },
    resources: {
      type: String
    },
    namecardCallback: {
      type: Function
    }
  },
  data: function() {
    var namecardInfo;
    namecardInfo = this._initNamecardName();
    return {
      namecardName: namecardInfo.name,
      imageUrl: namecardInfo.picture,
      loading: false,
      reload: false
    };
  },
  computed: {
    modalType: function() {
      if (this.namecard) {
        return 'edit';
      } else {
        return 'new';
      }
    },
    title: function() {
      if (this.namecard) {
        return '编辑组织名片';
      } else {
        return '新增组织名片';
      }
    },
    validate: function() {
      return this.namecardName && this.imageUrl;
    }
  },
  template: `<modal :title="title" class="namecard-modal" size="small" ref="modal">
  <template>
    <div class="modal-body">
      <form>
        <div class="modal-body-top">
          <div class="form-field required">
            <div class="form-field-head">
              <div class="form-field-title">名义组织<span class="helper-text">（接收者将会看到消息的发送者为此名义）</span></div>
            </div>
            <div class="form-field-input-container">
              <div class="form-field-input">
                <input class="form-field-value" placeholder="请输入" type="text" v-model.trim="namecardName">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body-bottom">
          <div class="form-field required">
            <div class="form-field-head mb-3">
              <div class="form-field-title">图片<span class="helper-text">（接收者将会看到消息的发送者为此名义）</span></div>
            </div>
            <div class="attachments">
              <div class="attachment-item">
                <label class="add-file-btn">
                  <div class="content-centered" v-show="!imageUrl && !loading">
                    <input hidden="true" type="file" @change="fileChanged">
                    <i class="slp-plus"></i>
                  </div>
                  <div class="content-centered gray-bg" v-show="loading">
                    <input hidden="true" type="file" @change="fileChanged">
                    <i class="slp-loading spin"></i>
                  </div>
                  <div class="content-centered" v-show="reload">
                    <div class="error-content error-text">
                      <div class="reload-btn">
                        <i class="slp-refresh-circle"></i>
                      </div>
                      <span>上传失败</span>
                    </div>
                  </div>
                  <div class="image-wrapper" v-show="imageUrl && !loading">
                    <img :src="imageUrl" @load="imageLoad"/>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </template>
  <template slot="footer">
    <div class="modal-footer">
      <button class="outlined btn-default" @click='cancel'>取消</button>
      <button @click="ensureClicked">确定</button>
    </div>
  </template>
</modal>`,
  methods: {
    cancel: function() {
      return this.$refs.modal.close();
    },
    fileChanged: function(event) {
      var image;
      this.loading = true;
      this.imageUrl = false;
      image = new Skylark.Libs.Storage.Image(event.target.files[0]);
      return image.upload({
        success: (data, xhr) => {
          return this.imageUrl = Skylark.Libs.Storage.publicImageUrl(data);
        },
        error: function(message, xhr) {
          this.loading = false;
          this.reload = true;
          return newAlertify(message.message, {
            type: 'error'
          });
        }
      });
    },
    imageLoad: function(event) {
      return this.loading = false;
    },
    ensureClicked: function() {
      var callback;
      callback = function(message, type) {
        return newAlertify(message, {
          type: type
        });
      };
      if (this.modalType === 'new') {
        return this._postNamecard({
          callback: callback,
          method: 'post',
          url: `${this.resources}`
        });
      } else {
        return this._postNamecard({
          callback: callback,
          method: 'put',
          url: `${this.resources}/${this.namecard.id}`
        });
      }
    },
    _postNamecard: function(options) {
      if (this.validate) {
        return Skylark.Libs.Ajax[options.method](options.url, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          data: {
            namecard: {
              name: this.namecardName,
              picture: this.imageUrl
            }
          },
          success: (data) => {
            options.callback('成功', 'success');
            this.$refs.modal.close();
            return this.namecardCallback({
              data: data,
              type: this.modalType
            });
          },
          error: function() {
            return options.callback('失败', 'error');
          }
        });
      } else {
        return options.callback('请填写完整', 'error');
      }
    },
    _initNamecardName: function() {
      if (this.namecard) {
        return {
          name: this.namecard.name,
          picture: this.namecard.picture
        };
      } else {
        return {
          name: '',
          picture: ''
        };
      }
    }
  }
});
